module.exports = __webpack_public_path__ + "img/tjx_d_19.5275ba33.png";